import { render, staticRenderFns } from "./PeopleInfo.vue?vue&type=template&id=b02ae56a&scoped=true&"
import script from "./PeopleInfo.vue?vue&type=script&lang=js&"
export * from "./PeopleInfo.vue?vue&type=script&lang=js&"
import style0 from "./PeopleInfo.vue?vue&type=style&index=0&id=b02ae56a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02ae56a",
  null
  
)

export default component.exports